import React from 'react';
import { Database, Key } from 'lucide-react';
import { Card } from '../../ui/Card'

// GH #4632 (ADR-046 roadmap R12): this view rendered literal key, certificate,
// rotation and expiration-alert rows, among them an active "Kyber-1024" key and
// a "PQ Ready" percentage. No key registry sits behind the console and
// socket-cloud-api holds no key material (GH #2704), so every figure was
// invented. Removed rather than gated: the view says that no source is
// connected until a key-registry API with a spec in schema-registry/ exists.
// The Import, Export, Generate Key, Rotate and Revoke controls went with the
// rows; each only wrote to the browser console.
export const KeyManagementDashboard: React.FC = () => (
  <div className="space-y-6">
    {/* Header */}
    <div className="flex items-center gap-3">
      <div className="p-2 bg-amber-600 rounded-lg">
        <Database className="w-6 h-6 text-white" />
      </div>
      <div>
        <h1 className="text-2xl font-bold text-console-text">Key Management</h1>
        <p className="text-console-muted">Cryptographic key and certificate lifecycle management</p>
      </div>
    </div>

    {/* Empty state: no key registry is connected */}
    <Card className="p-8" data-testid="key-management-empty-state">
      <div className="flex flex-col items-center text-center gap-3">
        <div className="p-3 bg-console-surface rounded-lg">
          <Key className="w-6 h-6 text-console-muted" />
        </div>
        <h2 className="text-lg font-semibold text-console-text">No key registry connected</h2>
        <p className="text-console-muted max-w-xl">
          This console has no source for key, certificate, rotation or expiration data.
          Those records appear here once a key registry is connected.
        </p>
      </div>
    </Card>
  </div>
);
